import React from "react";
import FractionInput from "../../../../components/inputs/FractionInput";
import { InlineMath, BlockMath } from "react-katex";

// ==== GENERATOR ====

export function generateTask() {
  const a1 = Math.floor(Math.random() * 46 + 5); // 5–50
  const q = Math.floor(Math.random() * 3) + 2;   // 2–4
  const n = Math.floor(Math.random() * 5) + 3;   // 3–7

  const an = a1 * Math.pow(q, n - 1);

  return {
    type: "FindDailyInfectionTask",
    data: { a1, q, n, an }
  };
}

// ==== RENDER ====

export function renderTask(task) {
  const { a1, q, n } = task.data;

  return (
    <>
      <p>
        Pierwszego dnia wykryto <InlineMath math={`${a1}`} /> przypadków zakażenia nowym wirusem.
        Liczba nowych przypadków codziennie rośnie <InlineMath math={`${q}`} />-krotnie.
      </p>
      <p>
        Ile wynosi <InlineMath math={`a_{${n}}`} /> – liczba nowych przypadków odnotowanych 
        <InlineMath math={`\\ ${n}`} />-tego dnia?
      </p>
    </>
  );
}


export function renderInput(task, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      placeholder="np. 432"
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
    />
  );
}

export function checkAnswer(task, userAnswer) {
  const { an } = task.data;
  if (!userAnswer || typeof userAnswer !== "object" || userAnswer.parsed == null) return false;
  return Math.abs(userAnswer.parsed - an) < 0.01;
}

export function renderAnswer(task) {
  return <InlineMath math={`a_{${task.data.n}} = ${task.data.an}`} />;
}

export function renderExplanation(task) {
  const { a1, q, n, an } = task.data;
  const power = n - 1;
  const pow = Math.pow(q, power);

  return (
    <div className="space-y-3" style={{ textAlign: "left" }}>
      <div><strong>Krok 1:</strong> Wzór na <InlineMath math={`a_n`} />:</div>
      <BlockMath math={`a_n = a_1 \\cdot q^{n-1}`} />

      <div><strong>Krok 2:</strong> Podstawiamy dane:</div>
      <BlockMath math={`a_{${n}} = ${a1} \\cdot ${q}^{${n - 1}}`} />

      <div><strong>Krok 3:</strong> Obliczamy:</div>
      <BlockMath math={`a_{${n}} = ${a1} \\cdot ${pow} = ${an}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  return <InlineMath math={`a_n = ${userAnswer.raw}`} />;
}

// ==== EXPORT ====

export default {
  generateTask,
  renderTask,
  renderInput,
  renderAnswer,
  renderExplanation,
  checkAnswer,
  renderUserAnswer
};
